module.exports = __webpack_public_path__ + "img/PoorIcon.5320f96f.svg";